module.exports = __webpack_public_path__ + "static/media/crs_vehicle_img.2098341c.gif";